module.exports = __webpack_public_path__ + "img/4.c12b63d3.jpg";